import { render, staticRenderFns } from "./No06.vue?vue&type=template&id=0544a936&scoped=true"
import script from "./No06.vue?vue&type=script&lang=js"
export * from "./No06.vue?vue&type=script&lang=js"
import style0 from "./No06.vue?vue&type=style&index=0&id=0544a936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544a936",
  null
  
)

export default component.exports